import { TagsFilterState } from './tags.types';

export const getDefaultTagFilter = (): TagsFilterState => ({
  tags: null,
});
export const defaultTagFilter = getDefaultTagFilter();
